import type { SpatialRectangle } from "../types/geometry/SpatialRectangle"
import type { Measure } from "../types/units/Units"

export const BoxToRectangle = <T extends Measure>([x, y, x2, y2]: [
  T,
  T,
  T,
  T,
]): SpatialRectangle<T> => ({
  x,
  y,
  width: (x2 - x) as T,
  height: (y2 - y) as T,
})
